import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import connect from 'components/lib/connect';
import Endpoint from 'models/endpoint';
import InitiateWarmTransfer from 'actions/phone_call/initiate_warm_transfer';
import SearchableAssignmentMenu from 'components/lib/assignment_menu/searchable_assignment_menu';
import SearchResult from 'components/lib/assignment_menu/search_result';
import TransferButtonOptions from 'components/lib/assignment_menu/transfer_button_options';

export class SearchableTransferMenu extends PureComponent {
  constructor(props) {
    super(props);
    this.renderAssignmentRow = this.renderAssignmentRow.bind(this);
  }
  render() {
    return (
      <SearchableAssignmentMenu
        className="searchableTransferMenu"
        conversationId={this.props.conversationId}
        excludedAgentIds={[this.props.currentAgentId]}
        inboxIds={this.props.inboxIds}
        onBlur={this.props.onClose}
        renderRow={this.renderAssignmentRow}
        title="Transfer"
      />
    );
  }
  renderAssignmentRow(hit) {
    return (
      <TransferSearchResultContainer
        agentClassName="transfer-selectableSearchResults"
        inboxButtons={
          <TransferButtonOptions
            agentId={hit.agentId}
            conversationId={this.props.conversationId}
            currentAgentId={this.props.currentAgentId}
            onClose={this.props.onClose}
            routingGroupId={hit.routingGroupId}
          />
        }
        inboxClassName="transfer-selectableSearchResults-group"
        key={`${hit.routingGroupId}${_.get(hit, 'agentId', '')}`}
        {...this.props}
        {...hit}
      />
    );
  }
}

SearchableTransferMenu.propTypes = {
  conversationId: PropTypes.string.isRequired,
  currentAgentId: PropTypes.string.isRequired,
  inboxIds: PropTypes.arrayOf(PropTypes.string),
  onClose: PropTypes.func.isRequired,
};

const SearchableTransferMenuContainer = connect(mapStateToMenuProps)(SearchableTransferMenu);

function mapStateToMenuProps({ getProvider }) {
  let allRoutingGroups = getProvider('routingGroups').findAll();
  let endpoints = getProvider('channelConfiguration').get().endpoints;
  let indexedQueues = _.groupBy(getProvider('communicationQueues').findAll(), 'routingGroupId');

  function isVoiceRoutingGroup(rg) {
    return _.some(indexedQueues[rg.id], cq =>
      _.some(endpoints, e => e.id === cq.endpointId && e.type === Endpoint.Type.VOICE)
    );
  }

  return {
    inboxIds: allRoutingGroups.filter(isVoiceRoutingGroup).map(i => i.id),
    currentAgentId: getProvider('currentAgent').get().id,
  };
}

export default SearchableTransferMenuContainer;

export class TransferSearchResult extends PureComponent {
  constructor(props) {
    super(props);
    this.onSelect = this.onSelect.bind(this);
  }

  onSelect() {
    this.props.onSelect({
      agentId: this.props.agentId,
      currentAgentId: this.props.currentAgentId,
      routingGroupId: this.props.routingGroupId,
    });
  }

  render() {
    return <SearchResult {...this.props} onAgentSelect={this.onSelect} />;
  }
}

TransferSearchResult.propTypes = {
  agentId: PropTypes.string,
  currentAgentId: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  routingGroupId: PropTypes.string,
};

function mapStateToProps({ getProvider }, props) {
  return {
    currentAgentId: getProvider('currentAgent').get().id,
  };
}

function mapExecuteToProps(executeAction) {
  return {
    onSelect: attrs => {
      executeAction(InitiateWarmTransfer, {
        fromAgentId: attrs.currentAgentId,
        toAgentId: attrs.agentId,
        toRoutingGroupId: attrs.routingGroupId,
      });
    },
  };
}

export const TransferSearchResultContainer = connect(mapStateToProps, mapExecuteToProps)(TransferSearchResult);



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/assignment_menu/searchable_transfer_menu.jsx